import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useUploadDocument = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({
			participantId,
			file,
			name,
		}: {
			participantId: number;
			file: File;
			name?: string;
		}) => {
			const formData = new FormData();
			formData.append("file", file);
			if (name) {
				formData.append("name", name);
			}

			return await EndpointsService.dataRetriever.uploadDocument({
				participantId,
				body: formData,
			});
		},
		onSuccess: (_data, variables) => {
			// Invalidate and refetch documents data
			queryClient.invalidateQueries({
				queryKey: ["documents", { participantId: variables.participantId }],
			});
		},
	});
};
